module.exports = __webpack_public_path__ + "img/18_56.26108307.png";